import { Component } from '@angular/core';

@Component({
    selector: 'shared-shared',
    template: ` <p>shared works!</p> `,
    styles: [],
    standalone: false
})
export class SharedComponent {}
